export default __webpack_public_path__ + "static/media/girl-modal.e3c65374.png";